import style from './style.module.scss'
import { Text, Header } from '@crossfit/design-system'

type Props = {
  headlineText?: string
  subheadlineText?: string
}

function Hero({ headlineText, subheadlineText }: Props) {
  return (
    <header className={style.wrapper}>
      <div className={style.innerWrapper}>
        <Header size='lg' as='h1'>
          {headlineText}
        </Header>
        {subheadlineText && (
          <Text as='p' size='md' type='body' className={style.subheadlineText}>
            {subheadlineText}
          </Text>
        )}
      </div>
    </header>
  )
}

export default Hero
